<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JUqCBt/tc-custom/9798886935288.jpg?1721404537743" alt="This image is the cover for the book Birthed Anew: From Pain to Passion to Purpose"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Birthed Anew: From Pain to Passion to Purpose
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>We all have a part deep within us that is fighting to make its exit. Whether it’s hidden secrets, traumatic experiences, or soul wrenching memories, it no longer wants to reside there. Let me introduce you to Grace. She weaves us through the course of her life as she embarks upon this quest for freedom from life’s shackles. On this journey, we experience her deeply rooted pain, and her drive towards deliverance. We witness her attempts of resurrection from the dark pits of pain to the moment of her personal triumph.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>Pursing growth commences through the identification of the who, what, where, when and why’s in our lives. Gaining a better understanding of how our past paves our future can help individuals make positive choices that will support authentic healing and restoration.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><em><span style='font-size:16px;font-family:"Times New Roman",serif;'>Birthed Anew: From Pain to Passion to Purpose</span></em><span style='font-size:16px;font-family:"Times New Roman",serif;'> will shed light on commonly hidden skeletons while simultaneously revealing the beauty of what it actually means to transition from a painful situation to a purposeful one and ultimately experience the gift of forgiveness.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Candace Mezetin
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0mm;font-size:16px;font-family:"Courier New";color:black;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:windowtext;'>Candace Mezetin has an immense love and passion for writing. It is the truest window to her soul. Since the age of eight, she has been writing short stories and poetry. Candace has worked as an occupational therapist for seven years, after which she home-schooled her four children for five years. She currently teaches science and math and is also a certified fitness instructor, but writing is her first love. Candace is a devoted mother to her four children, and has purposed her life towards leaving a legacy for them that will forever shine bright.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d90f1f3e